module.exports = new __parcel__URL__("PrivacyPolicy.47daa0e3.pdf").toString();